import React from 'react';
import { Result, Button } from 'antd';

interface State {
  hasError: boolean;
  isChunkError: boolean;
}

/**
 * ErrorBoundary для lazy-загружаемых страниц.
 * Ловит ошибки загрузки чанков (после деплоя хеши меняются)
 * и предлагает перезагрузить страницу вместо вечного спиннера.
 */
class LazyLoadErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    const msg = error?.message || '';
    const isChunkError =
      msg.includes('Loading chunk') ||
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Importing a module script failed') ||
      msg.includes('error loading dynamically imported module');
    return { hasError: true, isChunkError };
  }

  componentDidCatch(error: Error) {
    console.error('[LazyLoadErrorBoundary]', error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.state.isChunkError) {
        return (
          <Result
            status="warning"
            title="Обновление приложения"
            subTitle="Вышла новая версия. Необходимо обновить страницу."
            extra={
              <Button type="primary" onClick={this.handleReload}>
                Обновить страницу
              </Button>
            }
          />
        );
      }
      return (
        <Result
          status="error"
          title="Ошибка загрузки"
          subTitle="Не удалось загрузить страницу. Попробуйте обновить."
          extra={
            <Button type="primary" onClick={this.handleReload}>
              Обновить страницу
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default LazyLoadErrorBoundary;
